import { Text } from "@utdanningsdirektoratet/lisa";
import styled from "styled-components";

export const P = styled(Text).attrs({ as: "p" })`
	margin: 0;
`;
